module.exports = __webpack_public_path__ + "static/media/DeepCBCT_analysis.02c86a57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/DeepCBCT_analysis.svg
// module id = 204
// module chunks = 0